import { render } from "./SelectClaimedUndergroundToken.vue?vue&type=template&id=0fe65bcb&ts=true"
import script from "./SelectClaimedUndergroundToken.vue?vue&type=script&lang=ts"
export * from "./SelectClaimedUndergroundToken.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__